import React, { FC } from 'react'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { Text, Flex } from '@moonpig/launchpad-components'
import { NavigationalRow } from '../types'
import { LIST_ICON_SIZE_PX } from '../constants'

const StyledIconWrapper = styled(Flex)`
  ${s({
    bgcolor: 'colorBackground01',
    borderRadius: 1,
    p: 4,
    mr: 4,
    color: 'colorInteractionControl',
  })}
`

const StyledNavText = styled(Text)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`

export const NavigationalSuggestion: FC<{ row: NavigationalRow }> = ({
  row,
}) => {
  const item = row.item
  const Icon = item.icon
  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Flex alignItems="center">
        <StyledIconWrapper>
          {Icon && (
            <Icon
              width={LIST_ICON_SIZE_PX}
              height={LIST_ICON_SIZE_PX}
              aria-hidden
              typography={'typeBodyLabel'}
            />
          )}
        </StyledIconWrapper>
      </Flex>
      <StyledNavText typography={'typeBodyText'}>{item.value}</StyledNavText>
    </Flex>
  )
}
